import React from 'react';
import type { ActiveTab } from '../types';
import { Owner10HubShell } from '@/features/owner/components/Owner10HubShell';

interface Props {
  onSelectTab: (tab: ActiveTab) => void;
  onClose: () => void;
}

export const OrdersPublicationsHub: React.FC<Props> = ({ onSelectTab, onClose }) => {
  return (
    <Owner10HubShell
      title="Заказы и публикации"
      subtitle="Приём авторских заявок, заказы клиентов и совместные статьи в одном модуле."
      onClose={onClose}
      tabs={[
        { id: 'INTAKES', label: 'Авторские обращения' },
        { id: 'ORDERS', label: 'Заказы клиентов' },
        { id: 'ARTICLES', label: 'Совместные статьи' },
      ]}
      activeTab={undefined}
      onTabChange={(id) => onSelectTab(id as ActiveTab)}
      cards={[
        {
          id: 'INTAKES',
          code: 'АВТ',
          title: 'Авторские обращения',
          text: 'Услуги, готовые статьи, анкеты авторов, статусы и сообщения.',
          accent: '#41d2ff',
          cta: 'Открыть обращения',
          meta: ['рабочий модуль', 'единая точка входа'],
          onOpen: () => onSelectTab('INTAKES'),
        },
        {
          id: 'ORDERS',
          code: 'ЗАК',
          title: 'Заказы клиентов',
          text: 'Статьи, журналы, оплаты, этапы и сроки по заказам.',
          accent: '#49ddb7',
          cta: 'Открыть заказы',
          meta: ['рабочий модуль', 'единая точка входа'],
          onOpen: () => onSelectTab('ORDERS'),
        },
        {
          id: 'ARTICLES',
          code: 'СТТ',
          title: 'Совместные статьи',
          text: 'Общий реестр владельца и назначенного научного партнёра.',
          accent: '#e2ad3a',
          cta: 'Открыть статьи',
          meta: ['рабочий модуль', 'единая точка входа'],
          onOpen: () => onSelectTab('ARTICLES'),
        },
      ]}
      note="Авторские обращения, заказы клиентов и совместные статьи — в одном модуле с прежним функционалом."
    />
  );
};
